import React, { Component } from "react";
import {
  Box,
  Button,
  Grid,
  Autocomplete,
  TextField,
  CircularProgress,
} from "@mui/material";
import { withRouter } from "react-router-dom";
import "./style.css";
import Datatable from "../CommonComponents/Datatable/Datatable";
import BreadcrumbComp from "../CommonComponents/Breadcrumb/Breadcrumb";
import { connect } from "react-redux";
import { toastAlert } from "../../helpers/toastAlert";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../CommonComponents/RightDrawer";
import {
  getEmployees,
  toggleModal,
  handleChange,
  addEmployee,
  editEmployee,
  deleteEmployee,
  getRoles,
  normalizeRoleList,
} from "../../services/employeeService";
import { employeeListData } from "../../helpers/renderData";
import ConfirmDeleteModal from "../CommonComponents/Confrimationmodal";
import PasswordInput from "../CommonComponents/PasswordInput";
import ResetPasswordModal from "../CommonComponents/ResetPasswordModal";
import { resetEmployeePassword } from "../../services/employeeService";
import { getTasks } from "../../services/taskService";
import { hasPermission } from "../../utils/commonutils";
import MasterSelect from "../CommonComponents/MasterSelect";
import { FALLBACK_EMPLOYEE_DEPARTMENT } from "../../utils/masterFallbacks";

const ROLE_POPPER_PROPS = {
  popper: {
    sx: { zIndex: 40000 },
    modifiers: [{ name: "preventOverflow", enabled: false }],
  },
};

class EmployeeListComponent extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      tableData: {},
      page: 1,
      rowsPerPage: 10,
      Searchtax: "",
      showDeleteModal: false,
      resetPasswordTarget: null,
      deleteId: "",
      count: 1,
      roles: [],
      Orderdata:[],
      addModel: false,
      addError: [],
      addName: "",
      addEmail: "",
      addMobile: "",
      addDepartment: "",
      addRole: null,
      addPassword: "",

      // edit employee values
      editModel: false,
      editError: [],
      editName: "",
      editEmail: "",
      editMobile: "",
      editDepartment: "",
      editRole: null,
      userId: "",
    };
  }

  itemArray = () => {
    return [
      {
        name: "All Employees",
        active: true,
        link: "",
      },
    ];
  };

  closeAddModal = () => {
    this.setState({
      addModel: false,
      addError: [],
      addName: "",
      addEmail: "",
      addMobile: "",
      addDepartment: "",
      addRole: null,
      addPassword: "",
    });
  };

  closeEditModal = () => {
    this.setState({
      editModel: false,
      editError: [],
      editName: "",
      editEmail: "",
      editMobile: "",
      editDepartment: "",
      editRole: null,
    });
  };
  openResetPasswordModal = (data) => {
    this.setState({
      resetPasswordTarget: { id: data?._id, name: data?.name, email: data?.email },
    });
  };

   openDeleteModal = (id) => {
    this.setState({
      deleteId: id,
      showDeleteModal: true,
    });
  };

  deleteEmployee = async () => {
    if (!this?.state?.Orderdata.includes(this.state.deleteId)) {
    await deleteEmployee(this.state.deleteId, this.props);
    toastAlert("employee Deleted successfully", "success");
  }
  else{
    toastAlert("Cannot delete employee with active Task. Reassign or complete the Task to proceed.", "error");
  }
    this.getEmployees(this.state.page , this.state.rowsPerPage)
        this.setState({
      deleteId: "",
      showDeleteModal: false,
    });
  };

  setEditEmployee = async (employeeId, data) => {
    console.log("Edit Employee : ", employeeId, data);
    this.setState({
      editModel: true,
      editError: [],
      editId: employeeId,
      editName: data?.name,
      editEmail: data?.email,
      editMobile: data?.mobile,
      editDepartment: data?.department,
      editRole: data?.userId?.role ? { name: data.userId.role } : null,
      userId:data?.userId ? data?.userId?._id : data?._id,
    });
  };

  getRoles = async () => {
    try {
      let roles = await getRoles(this.props);
      const list = normalizeRoleList(roles);
      if (!list.length) {
        toastAlert("Could not load roles. Please retry or contact an admin.", "error");
      }
      this.setState({ roles: list });
    } catch (error) {
      console.log("error fetching roles", error);
      toastAlert("Could not load roles.", "error");
    }
  };

  getEmployees = async (page, rowsPerPage ,search) => {
    try {
      console.log("getEmployees function ", page, rowsPerPage, this.props);
      let employees = await getEmployees( this.props ,page, rowsPerPage ,search
      );
      console.log("getEmployees fetch data", employees);
      // passed props to getUsers function so it can redirect this props to clearCookie() function

      if (employees && employees?.data?.employees !== null) {
        this.setState({
          count: employees?.data?.total,
          page: page,
        });
        let tableData = await employeeListData(
          employees?.data?.employees,
          this
        );
        this.setState({
          tableData,
          loading: false,
        });
      } else {
        // error
        console.log(
          "error fetching employees : ",
          employees,
          employees?.message
        );
        let message =
          employees && employees?.message !== undefined
            ? employees?.message
            : "Problem Fetching Records.";
        toastAlert(message, "error");
        this.setState({ loading: false });
      }
    } catch (error) {
      console.log("error catch block", error);
      toastAlert("Please check Internet Connection.", "error");
      this.setState({ loading: false });
    }
  };

  addEmployee = async () => {
    const { addName, addEmail, addMobile, addDepartment, addPassword, addRole } =
      this.state;
    let error = [];

    if (!addName.trim()) {
      error.push("addName");
    }
    if (!addEmail.trim()) {
      error.push("addEmail");
    }
    if (!addMobile.trim()) {
      error.push("addMobile");
    }
    if (!addRole?.name) {
      error.push("addRole");
    }
      if (!/^[0-9]\d{9}$/.test(addMobile.trim()) && addMobile.trim()) {
      error.push("addmobileregx");
    }
    if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(addEmail.trim()) &&
      addEmail.trim()
    ) {
      error.push("addemailregx");
    }
    if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
        addPassword.trim()
      ) &&
      addPassword.trim()
    ) {
      error.push("adddPasswordregx");
    }
    if (!addPassword.trim()) {
      error.push("addPassword");
    }
    if (error.length > 0) {
      this.setState({
        addError: error,
      });
    } else {
      this.setState({
        addError: [],
      });

      try {
        console.log(" :->, Add Employee");
        let res = await addEmployee(this.props, this);
        console.log("Resolution", res);
        if ((res && res?.status === 201) || res?.code === 200) {
          toastAlert(
            res?.message ? res?.message : "employee added successfully",
            "success"
          );
          this.closeAddModal();
          this.getEmployees(this.state.page, this.state.rowsPerPage);
        } else {
          // error
          console.log("error adding service category : ", res, res.message);
          let message =
            res && res.message !== undefined
              ? res.message
              : "Problem while adding Records.";
          toastAlert(message, "error");
          this.closeAddModal();
        }
      } catch (error) {
        console.log("error catch block", error);
        toastAlert("Please check Internet Connection.", "error");
        this.closeAddModal();
      }
    }
  }; 
    getTskdata = async()=>{
          let tasks = await getTasks(this.props)
           const customerIdValues = Object.values(tasks?.data?.tasks?.tasks).map(task => task?.employeeId?._id)
            if (tasks?.data?.tasks) {
            this?.setState({
              Orderdata: customerIdValues,
            });
          }
      }
  editEmployee = async () => {
    const { editName, editEmail, editMobile, editRole } = this.state;
    let error = [];

    if (!String(editName || "").trim()) {
      error.push("editName");
    }
    if (!String(editEmail || "").trim()) {
      error.push("editEmail");
    }
    if (!String(editMobile || "").trim()) {
      error.push("editMobile");
    }
    if (!editRole?.name) {
      error.push("editRole");
    }
      if (!/^[0-9]\d{9}$/.test(String(editMobile || "").trim()) && String(editMobile || "").trim()) {
      error.push("editmobileregx");
    }
    if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(editEmail || "").trim()) &&
      String(editEmail || "").trim()
    ) {
      error.push("editEmailregx");
    }
    if (error.length > 0) {
      this.setState({
        editError: error,
      });
    } else {
      this.setState({
        editError: [],
      });
      try {
        console.log(" :->, Edit Employee");
        let res = await editEmployee(this.props, this);
        console.log("Resolution", res);
        if ((res && res?.data?.code === 201) || res?.data?.code === 200) {
          toastAlert(
            res?.message ? res?.message : "employee edited successfully",
            "success"
          );
          this.closeEditModal();
          this.getEmployees(this.state.page, this.state.rowsPerPage);
        } else {
          // error
          console.log("error adding service category : ", res, res.message);
          let message =
            res && res.message !== undefined
              ? res.message
              : "Problem while adding Records.";
          toastAlert(message, "error");
          this.closeEditModal();
        }
      } catch (error) {
        console.log("error catch block", error);
        toastAlert("Please check Internet Connection.", "error");
        this.closeEditModal();
      }
    }
  };

  componentDidMount() {
    this.getEmployees(this.state.page, this.state.rowsPerPage);
    this.getRoles();
    this.getTskdata()
  }

  handleDropDownChange = (e, val, action = "add") => {
    if (action === "edit") {
      this.setState({
        editRole: val,
      });
    } else {
      this.setState({
        addRole: val,
      });
    }
  };

  render() {
    const {
      tableData,
      loading,
      roles,
      addModel,
      addName,
      addEmail,
      addMobile,
      addDepartment,
      addRole,
      addPassword,
      addError,

      editModel,
      editName,
      editEmail,
      editMobile,
      editDepartment,
      editRole,
      editError,
    } = this.state;
    return (
      <div>
        <Grid container>
          <Grid item lg={12} sm={12} xs={12} md={12}>
          <Grid
  container
  alignItems="center"
  justifyContent="space-between"
  style={{ marginBottom: "16px" }}
>
  {/* Breadcrumb : Left */}
  <Grid item>
    <BreadcrumbComp items={this.itemArray()} />
  </Grid>

  {/* Add Employee Button : Right */}
  {hasPermission("create_employee") && (
    <Grid item>
                    <Button
                      className="btn btn-colored"
                      onClick={() => {
                        this.getRoles();
                        toggleModal(this);
                      }}
                    >
        + Add New Employee
      </Button>
    </Grid>
  )}
</Grid>

            {/* Add Employee Button : end */}

            {/* Add Employee modal : start */}
            <div>
              <Modal isOpen={addModel} toggle={() => this.closeAddModal()} size="lg">
                <ModalHeader toggle={() => this.closeAddModal()} kicker="Team">Add employee</ModalHeader>
                <ModalBody>
                  <Grid container spacing={2}>
                    {/* Row 1 */}
                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Employee Name *</p>
                      <input
                        className="input-main"
                        type="Text"
                        value={addName}
                        name="addName"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Employee Name"
                      />
                      {addError?.includes("addName") && (
                        <p className="error-message">
                          Employee Name shouldn't be empty
                        </p>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Employee Email *</p>
                      <input
                        className="input-main"
                        type="Email"
                        value={addEmail}
                        name="addEmail"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Employee Email Id"
                      />
                      {addError?.includes("addEmail") && (
                        <p className="error-message">
                          Employee Email shouldn't be empty
                        </p>
                      )}
                      {addError?.includes("addemailregx") && (
                        <p className="error-message">
                          Pleace enter valid Customer email.
                        </p>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Employee Mobile *</p>
                      <input
                        className="input-main"
                        type="Number"
                        value={addMobile}
                        name="addMobile"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Employee Mobile No."
                      />
                      {addError?.includes("addMobile") && (
                        <p className="error-message">
                          Employee Mobile No. shouldn't be empty
                        </p>
                      )}
                      {addError?.includes("addmobileregx") && (
                        <p className="error-message">
                          Mobile number must be 10 digits and Enter Valid
                          Mo.Number
                        </p>
                      )}
                    </Grid>

                    {/* Row 2 */}
                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Employee Department</p>
                      <MasterSelect
                        group="employee_department"
                        fallback={FALLBACK_EMPLOYEE_DEPARTMENT}
                        value={addDepartment}
                        placeholder="Select department"
                        onChange={(e) => this.setState({ addDepartment: e.target.value })}
                      />
                      {addError?.includes("addDepartment") && (
                        <p className="error-message">
                          Employee Department shouldn't be empty
                        </p>
                      )}
                    </Grid>
                     <Grid item xs={12} sm={6}>
                                          <p className="small-text">Role *</p>
                                          <Autocomplete
                                            name="addRole"
                                            value={addRole || null}
                                            options={roles || []}
                                            autoHighlight
                                            onChange={(e, val) => this.handleDropDownChange(e, val)}
                                            getOptionLabel={(option) =>
                                              typeof option === "string" ? option : option?.name || ""
                                            }
                                            isOptionEqualToValue={(option, value) =>
                                              option?.name === value?.name
                                            }
                                            slotProps={ROLE_POPPER_PROPS}
                                            ListboxProps={{ style: { maxHeight: 280 } }}
                                            renderOption={(props, option) => (
                                              <Box
                                                component="li"
                                                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                                {...props}
                                              >
                                                {option.name || ""}
                                              </Box>
                                            )}
                                            renderInput={(params) => (
                                              <TextField
                                                className="country-dropdown"
                                                {...params}
                                                placeholder="Select role"
                                                size="small"
                                                inputProps={{
                                                  ...params.inputProps,
                                                  autoComplete: "new-password",
                                                }}
                                              />
                                            )}
                                          />
                                          {addError?.includes("addRole") && (
                                            <p className="error-message">
                                              Role shouldn't be empty
                                            </p>
                                          )}
                                        </Grid>
                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Password *</p>
                      <PasswordInput
                        value={addPassword}
                        name="addPassword"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Employee Password"
                        autoComplete="new-password"
                      />
                      {addError?.includes("addPassword") && (
                        <p className="error-message">
                          Employee Password shouldn't be empty
                        </p>
                      )}
                      {addError?.includes("adddPasswordregx") && (
                        <p className="error-message">
                          Password must be 8+ characters, include uppercase,
                          lowercase, number & special character,
                        </p>
                      )}
                    </Grid>
                  </Grid>
                </ModalBody>

                <ModalFooter>
                  <Button
                    className="btn btn-border"
                    onClick={() => toggleModal(this)}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn btn-colored"
                    onClick={() => this.addEmployee()}
                  >
                    Save employee
                  </Button>
                </ModalFooter>
              </Modal>
            </div>
            {/* Add Employee modal : end */}

            {/* Edit Employee modal : start */}
            <div>
              <Modal isOpen={editModel} toggle={() => this.closeEditModal()} size="lg">
                <ModalHeader toggle={() => this.closeEditModal()} kicker="Team">Edit employee</ModalHeader>
                <ModalBody>
                  <Grid container spacing={2}>
                    {/* Row 1 */}
                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Employee Name *</p>
                      <input
                        className="input-main"
                        type="Text"
                        value={editName}
                        name="editName"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Employee Name"
                      />
                      {editError?.includes("editName") && (
                        <p className="error-message">
                          Employee Name shouldn't be empty
                        </p>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Employee Email *</p>
                      <input
                        className="input-main"
                        type="Email"
                        value={editEmail}
                        name="editEmail"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Employee Email Id"
                      />
                      {editError?.includes("editEmail") && (
                        <p className="error-message">
                          Employee Email shouldn't be empty
                        </p>
                      )}
                      {editError?.includes("editEmailregx") && (
                        <p className="error-message">
                          Please enter valid Customer email.
                        </p>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Employee Mobile *</p>
                      <input
                        className="input-main"
                        type="Number"
                        value={editMobile}
                        name="editMobile"
                        onChange={(evt) => handleChange(evt, this)}
                        placeholder="Employee Mobile No."
                      />
                      {editError?.includes("editMobile") && (
                        <p className="error-message">
                          Employee Mobile No. shouldn't be empty
                        </p>
                      )}
                      {editError?.includes("editmobileregx") && (
                        <p className="error-message">
                          Mobile number must be 10 digits and Enter Valid
                          Mo.Number
                        </p>
                      )}
                    </Grid>
                    {/* Row 2 */}
                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Employee Department</p>
                      <MasterSelect
                        group="employee_department"
                        fallback={FALLBACK_EMPLOYEE_DEPARTMENT}
                        value={editDepartment}
                        placeholder="Select department"
                        onChange={(e) => this.setState({ editDepartment: e.target.value })}
                      />
                      {editError?.includes("editDepartment") && (
                        <p className="error-message">
                          Employee Department shouldn't be empty
                        </p>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <p className="small-text">Role *</p>
                      <Autocomplete
                        name="editRole"
                        value={editRole || null}
                        options={roles || []}
                        autoHighlight
                        onChange={(e, val) => this.handleDropDownChange(e, val, "edit")}
                        getOptionLabel={(option) =>
                          typeof option === "string" ? option : option?.name || ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option?.name === value?.name
                        }
                        slotProps={ROLE_POPPER_PROPS}
                        ListboxProps={{ style: { maxHeight: 280 } }}
                        renderOption={(props, option) => (
                          <Box component="li" {...props}>
                            {option.name || ""}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select role"
                            size="small"
                          />
                        )}
                      />
                      {editError?.includes("editRole") && (
                        <p className="error-message">Role shouldn't be empty</p>
                      )}
                    </Grid>

                  </Grid>
                </ModalBody>
                <ModalFooter>
                  <Button
                    className="btn btn-border"
                    onClick={() => this.closeEditModal(this)}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn btn-colored"
                    onClick={() => this.editEmployee()}
                  >
                    Save changes
                  </Button>
                </ModalFooter>
              </Modal>
            </div>
            {/* Edit Employee modal : end */}

            {/*User_List_section::Start */}
            <Grid container className="data-table-main">
              <Grid item lg={12} sm={12} md={12} xs={12}>
                <div className="card-main" style={{ width: "100%" }}>
                  {loading ? (
                    <CircularProgress style={{ color: "#5F5BA8" }} size={50} />
                  ) : (
                    <Datatable
                      props={tableData}
                      title="All Employees"
                      currentPage={this?.state?.page}
                      TotalRow={this?.state?.count}
                      rowsPerPage={this?.state?.rowsPerPage}
                      onPageChange={(page, rows) => {
                        this.setState({
                          page: page,
                          rowsPerPage: rows,
                        });
                        this.getEmployees(page, rows);
                      }}
                      onSearchChange={(search) => {
                        this.setState({
                          Searchtax: search,
                          page: 1,
                        });
                        this.getEmployees(1, this.state.rowsPerPage, search);
                      }}
                    />
                  )}
                  <ConfirmDeleteModal
                    open={this.state.showDeleteModal}
                    onClose={() => this.setState({ showDeleteModal: false })}
                    onConfirm={this.deleteEmployee}
                    message="Are you sure you want to delete this employee?"
                  />
                  <ResetPasswordModal
                    open={Boolean(this.state.resetPasswordTarget)}
                    target={this.state.resetPasswordTarget}
                    onReset={resetEmployeePassword}
                    onClose={() => this.setState({ resetPasswordTarget: null })}
                  />
                </div>
              </Grid>
            </Grid>
            {/*User_List_section::End */}
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.authReducer,
});

export default withRouter(connect(mapStateToProps)(EmployeeListComponent));
